"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
const styles = (theme) => (0, core_1.createStyles)({
    container: material_kit_pro_react_1.container,
    coloredShadow: material_kit_pro_react_1.coloredShadow,
    centered: {
        display: 'flex',
        justifyContent: 'center'
    },
    header: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2)
    },
    imageContainer: {
        overflow: 'hidden',
        maxHeight: 480,
        [theme.breakpoints.down('lg')]: {
            maxHeight: 450
        },
        [theme.breakpoints.down('md')]: {
            maxHeight: 400
        },
        [theme.breakpoints.down('xs')]: {
            maxHeight: 360
        }
    },
    carouselContainer: {
        '& .slick-dots': {
            marginBottom: '-15px',
            [theme.breakpoints.down('md')]: {
                marginBottom: '3.5rem'
            },
            [theme.breakpoints.down('xs')]: {
                marginBottom: '-3.8rem'
            },
            '& li ': {
                '& button::before': {
                    backgroundColor: theme.palette.primary.light
                }
            }
        }
    },
    rewardCarousel: {
        '& .slick-dots': {
            marginLeft: '0rem',
            [theme.breakpoints.down('md')]: {
                marginBottom: '-1.8rem'
            },
            [theme.breakpoints.down('xs')]: {
                marginBottom: '-1.8rem'
            },
            '& li ': {
                '& button::before': {
                    backgroundColor: theme.palette.grey[500]
                }
            }
        },
        '& .slick-slide': {
            padding: '.5rem'
        }
    },
    carouselImage: {
        height: '553px',
        [theme.breakpoints.down('xs')]: {
            height: '412px'
        }
    },
    cardBody: {
        marginBottom: theme.spacing(8),
        [theme.breakpoints.down('xs')]: {
            marginBottom: 0
        }
    },
    chip: {
        margin: theme.spacing(),
        '&:first-child': {
            marginLeft: 0
        }
    },
    categoryHeader: {
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(3)
    },
    categoryCarousel: {
        '& .slick-slide': {
            padding: '.5rem'
        }
    },
    divider: {
        backgroundColor: theme.palette.text.secondary,
        marginBottom: theme.spacing(5)
    },
    sectionStyle: {
        [theme.breakpoints.down('lg')]: {
            marginTop: theme.spacing()
        },
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing()
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(5)
        }
    },
    secondaryColor: {
        color: theme.palette.text.secondary
    }
});
exports.default = styles;
//# sourceMappingURL=RewardsScreenStyle.js.map